import React, { useState } from "react";
import { Link, Redirect } from "react-router-dom";
import logo from "../images/logo.png";

function ClickPicture(props) {
  const [redirect, setRedirect] = useState(false);
  const [error, setError] = useState("");

  const handleClickFinishRegistration = async () => {
    const data = {
      clickPictureVisited: true,
    };

    const returnValue = await props.handleFinishRegistration(data);
    console.log("returnValue", returnValue);
    if (returnValue) {
      setRedirect(true);
    } else {
      setError("Something Went Wrong");
    }
  };

  return (
    <div className="cmn-bg">
      {!props.state.email || !props.state.employeId ? (
        <Redirect to="/register"></Redirect>
      ) : null}
      {redirect ? (window.location.href = "/sapworld.html") : null}
      {/* //TODO to be added later */}
      {/* (window.location.href = "/sapworld.html") */}
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="text-center">
              <Link to="/">
                <img src={logo} alt="logo" className="logo" />
              </Link>
              <form action="#" method="post" className="reg-form">
                {error ? <p>{error}</p> : null}
                <div className="row align-items-center">
                  <div className="col-12">
                    <p className="text-center text-yellow">
                      THIS IS A POSTCARD FROM US TO YOU!
                      <span className="text-blk">
                        CLICK A PICTURE OF YOU OR YOUR FAMILY AND WE'LL MAKE YOU
                        A KEEPSAKE!
                      </span>
                    </p>
                  </div>
                </div>

                <div className="row justify-content-center">
                  <div className="col-8">
                    <div
                      className=""
                      style={
                        {
                          // display: "flex",
                          // justifyContent: "center",
                          // alignItems: "stretch",
                        }
                      }
                    >
                      <iframe
                        id="inlineFrameExample"
                        title="Inline Frame Example"
                        width="100%"
                        height="400px"
                        style={{ border: "none" }}
                        src="https://phase1eventslive.com/sapworld/magzine-cover/"
                        allow="camera; microphone"
                      ></iframe>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 my-2">
                    <input
                      type="button"
                      className="register-btn text-uppercase"
                      value="Finish Registration"
                      onClick={handleClickFinishRegistration}
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ClickPicture;
